enum DeviceType {
  SPINE = 'spine',
  VALVE = 'valve'
}

export default DeviceType
